import http from '../services/http';

export default class feedbackService {
  constructor($http) {
    this.$http = $http;
  }

  submitAdviceForFeedback(content, contact, visaCountryId) {
    return http.post('h5/user_advice_add', {
      visa_country_id: visaCountryId,
      content,
      contact,
    });
  }

  getVisaCountryTotalQuery() {
    return http.post('h5/visa_country_total_query', {});
  }
}
